
const version = 'v1.4.9 - develop - 323b88ed';

export default version;
